module.exports = __webpack_public_path__ + "static/img/pic_pctop3zrdaoshi@2x.8884d8aa.png";